import { BuyOneGetMany } from '@appcharge/shared-ui';

import { ETemplateStudioLayoutOptions, EThemes } from '../enums';

import { BuyOneGetManyDesignsMetadata } from './types';

const defaultBuyOneGetMany: BuyOneGetManyDesignsMetadata = {
  id: 'buyOneGetManyDefault',
  theme: EThemes.ROYAL_BLAST,
  version: '1.0.0',
  name: '1+Many',
  createdAt: '2026-05-03T00:00:00.000Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/default_buy_one_get_many_no_design.png'
  ],
  layout: [
    ETemplateStudioLayoutOptions.HORIZONTAL,
    ETemplateStudioLayoutOptions.VERTICAL
  ],
  rewardsLayouts: [1, 2, 3],
  component: BuyOneGetMany
};

export const buyOneGetManyDesigns = {
  defaultBuyOneGetMany
};

export const buyOneGetManyDesignsByTheme: Record<
  EThemes,
  BuyOneGetManyDesignsMetadata[]
> = Object.values(buyOneGetManyDesigns).reduce(
  (acc, design) => {
    if (!acc[design.theme]) {
      acc[design.theme] = [];
    }
    acc[design.theme].push(design);
    return acc;
  },
  {} as Record<EThemes, BuyOneGetManyDesignsMetadata[]>
);

export const buyOneGetManyDesignsById: Record<
  string,
  BuyOneGetManyDesignsMetadata
> = Object.values(buyOneGetManyDesigns).reduce(
  (acc, design) => {
    acc[design.id] = design;
    return acc;
  },
  {} as Record<string, BuyOneGetManyDesignsMetadata>
);
